import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from './redux';
import AuthActions from '../redux/auth/action';
import { IUser } from '../models/user.model';

export function useAuthReady() {
  return useAppSelector((state) => state.auth.ready);
}

export function useAuth() {
  return useAppSelector((state) => state.auth);
}

export function useSetAuth() {
  const dispatch = useAppDispatch();

  return useCallback(
    (isAuth: boolean, user?: IUser) => {
      dispatch(AuthActions.setAuth(isAuth));
      dispatch(AuthActions.setUser(user));
    },
    [dispatch],
  );
}

export function useSignOut() {
  const setAuth = useSetAuth();

  return useCallback(() => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setAuth(false, undefined);
  }, [setAuth]);
}
